import styled from 'styled-components';

import { SPACING } from '~/common/constants/spacing';

export const SubmenuListItem = styled.li`
  position: relative;
  transition: 200ms;
  background-color: ${({ theme }) => theme.neutral[900]};
  border-radius: ${SPACING._4};
`;

export const ChildrenList = styled.ul<{
  open: boolean;
  height: string;
}>`
  position: absolute;
  width: 100%;
  transition: 200ms;
  height: ${({ height }) => height};
  z-index: 1;
  opacity: ${({ open }) => (open ? 1 : 0)};
  pointer-events: ${({ open }) => (open ? 'all' : 'none')};
`;
